export const useStyles = (theme) => ({
  styledTextField: {
    "& label": { color: theme.palette.text.black1 },
    "& div": { color: "#212121 !important" },
    "& fieldset": { borderColor: "#828282 !important" },
  },
});
